import useAxios from "./useAxios";

export function useLogout() {
  const [loading, sendRequest] = useAxios();

  const logout = () => {
  localStorage.setItem("SESSION_LOGOUT_BROADCAST", new Date().getTime().toString());
    let apitoken = localStorage.getItem("api_token");

    sendRequest(
      {
        url: `${process.env.REACT_APP_BASE_URL}/new/logout`,
        method: "GET",
        //data: inputdata,
        headers: {
          "api-token": apitoken,
        },
      }
    )
      .then((res) => {
        console.log(res);
        localStorage.clear();
        window.location.href = "/";
      })
      .catch((err) => {
        console.log(err);
        localStorage.clear();
        window.location.href = "/";
      });
  };

  return [logout, loading];
}

export function generateId(length) {
  let result = "";
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return result;
}
